export default "__VITE_ASSET__BSyHoVXn__"